'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alerts", "alertStore", "className", "onAlertClose", "style", "use"],
  _excluded2 = ["id", "message", "onClose", "timestamp", "titleText", "type"];
import classNames from 'classnames';
import { PureComponent } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import partial from 'react-utils/partial';
import { callIfPossible } from '../core/Functions';
import UILayer from '../layer/UILayer';
import AlertListTransition from './AlertListTransition';
import FloatingAlertStore from './FloatingAlertStore';
import UIFloatingAlert from './UIFloatingAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TOP_OFFSET = 20;
const NAV_BAR_ELEMENT_ID_V4 = 'hs-nav-v4';
const FLOATING_ALERT_SUBSCRIPTION_KEY = 'UIFloatingAlertList';
let subscriptionKeyId = 0;
const sortAlerts = (alertsFromProps, alertsFromStore) => [...alertsFromProps, ...alertsFromStore].sort((a, b) => {
  return a.timestamp - b.timestamp;
});
const subscribeToAlertStore = (instance, alertStore) => {
  alertStore.subscribe(instance.storeSubscriptionKey, alertsFromStore => {
    instance.setState({
      alertsFromStore
    });
  });
};
const unsubscribeFromAlertStore = (instance, alertStore) => {
  alertStore.unsubscribe(instance.storeSubscriptionKey);
};
const getStyle = (style, topOffset) => Object.assign({}, style, {
  top: topOffset
});
class UIFloatingAlertList extends PureComponent {
  constructor(props) {
    super(props);
    this.updateContainerOffset = () => {
      const {
        scrollTop
      } = document.documentElement;
      const navElement = document.getElementById(NAV_BAR_ELEMENT_ID_V4);
      let navHeight = 0;
      if (navElement) {
        navHeight = navElement.clientHeight;
      }
      const maxTopOffset = DEFAULT_TOP_OFFSET + navHeight;
      if (scrollTop > navHeight) {
        this.setState({
          topOffset: DEFAULT_TOP_OFFSET
        });
      } else {
        this.setState({
          topOffset: maxTopOffset - scrollTop
        });
      }
    };
    this.handleAlertClose = (alert, evt) => {
      const {
        onAlertClose
      } = this.props;
      callIfPossible(alert.onClose, evt, alert);
      callIfPossible(onAlertClose, evt, alert);
    };
    this.state = {
      alertsFromStore: [],
      topOffset: null
    };
    this._getStyle = memoizeOne(getStyle);
    this.storeSubscriptionKey = `${FLOATING_ALERT_SUBSCRIPTION_KEY}-${subscriptionKeyId++}`;
  }
  componentDidMount() {
    const {
      alertStore,
      use
    } = this.props;
    if (use !== 'contextual') {
      window.addEventListener('scroll', this.updateContainerOffset);
      this.updateContainerOffset();
    }
    subscribeToAlertStore(this, alertStore);
  }
  componentDidUpdate(prevProps) {
    const {
      alertStore
    } = this.props;
    if (prevProps.alertStore !== alertStore) {
      unsubscribeFromAlertStore(this, prevProps.alertStore);
      subscribeToAlertStore(this, alertStore);
    }
  }
  componentWillUnmount() {
    const {
      alertStore,
      use
    } = this.props;
    if (use !== 'contextual') {
      window.removeEventListener('scroll', this.updateContainerOffset);
    }
    unsubscribeFromAlertStore(this, alertStore);
  }
  render() {
    const _this$props = this.props,
      {
        alerts,
        className,
        style,
        use
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      alertsFromStore,
      topOffset
    } = this.state;
    const renderedAlerts = sortAlerts(alerts, alertsFromStore).map(alert => {
      const {
          id,
          message,
          titleText,
          type
        } = alert,
        alertRest = _objectWithoutPropertiesLoose(alert, _excluded2);
      return /*#__PURE__*/_jsx(UIFloatingAlert, Object.assign({
        onClose: partial(this.handleAlertClose, alert),
        titleText: titleText,
        type: type
      }, alertRest, {
        children: message
      }), id);
    });
    const computedClassName = classNames('private-floating-alert-list', className, use === 'contextual' && 'private-floating-alert-list--contextual');
    const computedStyle = this._getStyle(style, topOffset);
    const renderedAlertList = /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
      className: computedClassName,
      style: computedStyle,
      children: /*#__PURE__*/_jsx("div", {
        className: "private-floating-alert-list__child-wrapper",
        children: /*#__PURE__*/_jsx(AlertListTransition, {
          children: renderedAlerts
        })
      })
    }));
    if (use === 'contextual') {
      return renderedAlertList;
    }
    return /*#__PURE__*/_jsx(UILayer, {
      "data-layer-for": "UIFloatingAlertList",
      children: renderedAlertList
    });
  }
}
UIFloatingAlertList.displayName = 'UIFloatingAlertList';
UIFloatingAlertList.defaultProps = {
  alerts: [],
  alertStore: FloatingAlertStore,
  use: 'fullscreen'
};
export default UIFloatingAlertList;